import { Link } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import styles from './NotFound.module.css';

// Ruta desconocida (path="*"): antes mandaba a /login en silencio. Ahora avisa
// y ofrece volver al inicio (dashboard con sesión, login sin sesión).
export default function NotFound() {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading"><div className="spinner" /></div>;

  const destino = user ? '/dashboard' : '/login';

  return (
    <div className={styles.pagina}>
      <div className={styles.tarjeta}>
        <div className={styles.brujula}>
          <i className={`fas fa-compass ${styles.brujulaGlifo}`} aria-hidden="true" />
        </div>

        <h1 className={styles.titulo}>
          Esta página no existe
        </h1>

        <p className={styles.texto}>
          La dirección que abriste no existe o el enlace ya no es válido.
          Revisa que esté bien escrita o vuelve al inicio.
        </p>

        <Link to={destino} replace className="btn btn-primary">
          {user ? 'Ir al panel' : 'Ir a iniciar sesión'}
        </Link>
      </div>
    </div>
  );
}
